module.exports = __webpack_public_path__ + "static/media/federico-jack.54dea438.png";